import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Box } from '@components/Box';
import { JoykitIcon } from '@components/JoykitIcon';
import { Form, Footer } from '@sections/chat-gpt';
import { chatGPTPageData } from '@data-ts/pages/chat-gpt';
import { LoadingSpinner } from '@sections/chat-gpt/components/LoadingSpinner/LoadingSpinner';
import { LoadingAnimation } from '@sections/chat-gpt/components/LoadingAnimation/LoadingAnimation';
import { LogoSpreadAnimation } from '@sections/chat-gpt/components/LogoSpreadAnimation/LogoSpreadAnimation';
import { useWeddingWritersUnblocker } from './WeddingWritersUnblocker.controller';
import {
  StyledSection,
  StyledFlex,
  Title,
  StyledText,
  CopyButton,
  CopyText,
  ResponseWrapper,
  ResponseComponent,
  ResponseContainer,
  ResponseText,
  CloseButton,
  HEADER_HEIGHT,
} from './WeddingWritersUnblocker.styles';

const weddingWritersUnblockerData = chatGPTPageData.sections.weddingWritersUnblocker;

export const WeddingWritersUnblocker: React.FC = () => {
  const {
    loading,
    copyText,
    responseText,
    responseStatus,
    mobileSlideClass,
    handleOnClose,
    handleOnSubmit,
    handleClick,
  } = useWeddingWritersUnblocker();

  return (
    <StyledSection as="section" id="Wedding_Writers_Unblocker" flexDirection={['column', 'row']}>
      <StyledFlex marginTop={[0, HEADER_HEIGHT]} paddingTop={12} paddingBottom={8} flexDirection="column" justifyContent="space-between">
        <Box style={{ height: 'fit-content', textAlign: 'center' }} paddingX={6} paddingTop={[0, 1]}>
          <Box marginBottom={10}>
            <Title color="mono1" variant="hed56" tagName="h1" textAlign="center">
              {ReactHtmlParser(weddingWritersUnblockerData.title)}
            </Title>
            <StyledText color="black" variant="featureCopy17" tagName="h2" textAlign="center">
              {weddingWritersUnblockerData.body}
            </StyledText>
          </Box>
          <Form handleOnSubmit={handleOnSubmit} />
        </Box>
        <Footer />
      </StyledFlex>
      <ResponseWrapper className={mobileSlideClass}>
        <CloseButton id="ChatGPTCloseResponse" onClick={handleOnClose}>
          <JoykitIcon name="notAttending" color={'neutra6'} />
        </CloseButton>
        <ResponseComponent marginTop={[0, HEADER_HEIGHT]} paddingBottom={10} paddingTop={[10, 12]} paddingX={[7, 6]}>
          {loading && (
            <>
              <LoadingAnimation />
              <LoadingSpinner text={weddingWritersUnblockerData.loadingText} />
            </>
          )}
          {responseText.length < 1 && !loading && <LogoSpreadAnimation />}
          <ResponseContainer marginX="auto">
            {responseText.length > 0 && (
              <CopyButton id="ChatGPTCopyResponse" onClick={handleClick} skipRedirectWithTelemetry>
                <JoykitIcon name="copy" color="neutra4" size={24} />
                <CopyText color="neutra4" variant="featureCopy17" tagName="span">
                  {copyText}
                </CopyText>
              </CopyButton>
            )}
            {responseText.length > 0 && !loading && (
              <ResponseText color={responseStatus === 200 ? 'black' : 'covidCalculatorHighRiskIndicator'} fullText={responseText} />
            )}
          </ResponseContainer>
        </ResponseComponent>
      </ResponseWrapper>
    </StyledSection>
  );
};
